import { Typography, Breadcrumbs, Link } from "@mui/material";

const DetailTitle = ({ id }) => {
  return (
    <div className="w-full mb-6">
      <Breadcrumbs aria-label="breadcrumb">
        <Link underline="hover" color="inherit" href="/">
          Ana Ekran
        </Link>
        <Link underline="hover" color="inherit" href="/categories/0">
          Kategoriler
        </Link>
        <Typography color="text.primary">
          {id < 1 && <span>Kategori Ekle</span>}
          {id > 0 && <span>Kategori Düzenle</span>}
        </Typography>
      </Breadcrumbs>
    </div>
  );
};

export default DetailTitle;
